import {AfterViewInit, Component, OnInit, Renderer2, OnDestroy, EventEmitter,  Output} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {ConstantsService, RecursosEnum} from "../../fidelidade/ConstantsService";
import {MonitoradorPedidos} from "../../fidelidade/MonitoradorPedidos";
import {RotaGuardClient} from "../../guards/auth-loja.guard";
import {Location} from "@angular/common";
import {DeviceDetectorService} from "ngx-device-detector";
import {ServidorImpressaoExecutorService} from "../../services/servidor-impressao-executor.service";
import {serialization} from "blockly";
declare var $;
@Component({
  selector: 'app-menu-fidelidade',
  templateUrl: './menu-fidelidade.component.html',
  styleUrls: ['./menu-fidelidade.component.scss']
})
export class MenuFidelidadeComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() onFecharLoja  = new EventEmitter();
  @Output() onAbrirLoja  = new EventEmitter();
  @Output() onGerenciarJobs  = new EventEmitter();
  url = 'index';
  usuario: any;
  empresa: any = {};
  exibirFuncoesPedidos: boolean;
  exibirFuncoesMesas: boolean;
  exibirProdutos: boolean;
  exibirFuncoesFidelidade: boolean;
  exibirFuncoesChatbot: boolean;
  possuiModuloMiaV3: boolean;
  possuiModuloGarcom: boolean;
  possuiModuloApp: boolean;
  somenteCardapio: boolean;
  carregou = false;
  wizard: any;
  botAtivo: boolean;
  exibirChatBot: boolean;
  ehGarcom: boolean;
  resumoMesas: any = {}
  resumoPedidos: any = {totalErroParceiro : 0, totalPendenteOnline: 0, totalContestados: 0, totalErrosImportar: 0,
    totalErroParceiroMesa: 0};
  resumoEstoque: any  = { totalAlertas: 0}
  possuiModuloInstagramBot = false;
  exibirEntregadores: boolean;
  possuiModuloPDV: boolean;
  possuiModuloKDS: boolean;
  possuiModuloFiado: boolean;
  possuiModuloFiscal: boolean;
  possuiModuloTabelaPrecos: boolean;
  possuiModuloComissionamento: boolean;
  possuiRecursoAvaliacoesPedidos: boolean;
  possuiRecursoImpressaoAutomatica: boolean;
  possuiRecursoNotificacoesWhatsappPedidos: boolean;
  possuiRecursoIntegracaoGatewayPagamento: boolean;
  possuiRecursoIntegracaoPdvParceiros: boolean;
  possuiRecursoIntegracaoDeliveryParceiros: boolean;
  possuiRecursoIntegracaoMarketplacesDelivery: boolean;
  possuiRecursoVitrines: boolean;
  possuiRecursoCuponsAvancados: boolean;
  possuiRecursoTemasPersonalizados: boolean;
  possuiRecursoLinkNaBio: boolean;
  possuiRecursoInteligenciaNegocio: boolean;
  possuiRecursoCampanhasWhatsapp: boolean;
  possuiRecursoNotificacoesAppProprio: boolean;
  possuiRecursoFerramentasMarketing: boolean;
  exibirEstoque: boolean;
  isMobile = false;
  numeroWhatsappPrincipal: string = '';
  private clickHandler: Function;

  constructor( private router: Router, private renderer: Renderer2, private route: ActivatedRoute,
               private location: Location, private deviceService: DeviceDetectorService,
               private autorizacaoService: AutorizacaoService, private  constantsService: ConstantsService,
               public monitoradorPedidos: MonitoradorPedidos ,  public servidorExecutor: ServidorImpressaoExecutorService) {

    if(this.location.path()){
      const path = this.location.path();
      const adminIndex = path.indexOf('/admin/');
      this.url = adminIndex >= 0 ? path.substring(adminIndex + 7) : path.split('/').pop();
    }

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.url = route.snapshot.firstChild.routeConfig.path;
      }
    });

    this.isMobile = this.deviceService.isMobile()
  }

  ngAfterViewInit(): void {
    const leftSide = document.querySelector('.left-side-menu');
    if (leftSide) {
      this.clickHandler = this.renderer.listen(leftSide, 'click', (event: Event) => {
        const target = event.target as HTMLElement;
        let currentElement = target;

        // Verifica o elemento atual e seus pais até encontrar um com data-toggle="collapse"
        while (currentElement && currentElement !== leftSide) {
          if (currentElement.getAttribute('data-toggle') === 'collapse') {
            if (document.body.classList.contains('enlarged')) {
              event.preventDefault();
              event.stopPropagation();
              return false;
            }
            break;
          }
          currentElement = currentElement.parentElement;
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.clickHandler) {
      this.clickHandler();
    }
  }

  ngOnInit() {
    this.usuario = this.autorizacaoService.getUser();
    this.ehGarcom = this.usuario && this.usuario.garcom;
    this.constantsService.empresa$.subscribe( (empresa: any) => {
      if(empresa && empresa.id){
        this.empresa = empresa;
        this.carregou = true;
        this.wizard = empresa.exibirWizard;
        this.identificarNumeroWhatsappPrincipal();

        if(this.wizard)
          return this.naveguePara('wizard');

        if(this.somenteCardapio && location.pathname === '/admin/index'  )
          this.naveguePara('produtos');
      }
      $('.slimscroll-menu').slimscroll({
        height: 'auto',
        position: 'right',
        size: "8px",
        color: '#9ea5ab',
        wheelStep: 5,
        touchScrollStep: 20
      });

    })
    this.constantsService.moduloPedido$.subscribe( data =>   this.exibirFuncoesPedidos = data && !this.ehGarcom);
    this.constantsService.moduloMesasGarcom$.subscribe(data => this.exibirFuncoesMesas = data && !this.ehGarcom);
    this.constantsService.exibirProdutos$.subscribe( data =>   {
      this.exibirProdutos = data && !this.ehGarcom

      if(!RotaGuardClient.cadastrarProdutos(this.usuario))
        this.exibirProdutos = false;

    });
    this.constantsService.moduloEntregadores$.subscribe(data => this.exibirEntregadores = data && !this.ehGarcom);
    this.constantsService.moduloPdv$.subscribe(data => this.possuiModuloPDV = data && !this.ehGarcom);
    this.constantsService.possuiModuloKDS$.subscribe(data => this.possuiModuloKDS = data && !this.ehGarcom);
    this.constantsService.moduloFiado$.subscribe(data => this.possuiModuloFiado = data && !this.ehGarcom);
    this.constantsService.moduloFiscal$.subscribe(data => this.possuiModuloFiscal = data && !this.ehGarcom);
    this.constantsService.moduloTabelaPrecos$.subscribe(data => this.possuiModuloTabelaPrecos = data && !this.ehGarcom);
    this.constantsService.moduloComissionamento$.subscribe(data => this.possuiModuloComissionamento = data && !this.ehGarcom);
    this.constantsService.recursoAvaliacoesPedidos$.subscribe(data => this.possuiRecursoAvaliacoesPedidos = data && !this.ehGarcom);
    this.constantsService.recursoImpressaoAutomatica$.subscribe(data => this.possuiRecursoImpressaoAutomatica = data && !this.ehGarcom);
    this.constantsService.recursoNotificacoesWhatsappPedidos$.subscribe(data => this.possuiRecursoNotificacoesWhatsappPedidos = data && !this.ehGarcom);
    this.constantsService.recursoIntegracaoGatewayPagamento$.subscribe(data => this.possuiRecursoIntegracaoGatewayPagamento = data && !this.ehGarcom);
    this.constantsService.recursoIntegracaoPdvParceiros$.subscribe(data => this.possuiRecursoIntegracaoPdvParceiros = data && !this.ehGarcom);
    this.constantsService.recursoIntegracaoDeliveryParceiros$.subscribe(data => this.possuiRecursoIntegracaoDeliveryParceiros = data && !this.ehGarcom);
    this.constantsService.recursoIntegracaoMarketplacesDelivery$.subscribe(data => this.possuiRecursoIntegracaoMarketplacesDelivery = data && !this.ehGarcom);
    this.constantsService.recursoVitrines$.subscribe(data => this.possuiRecursoVitrines = data && !this.ehGarcom);
    this.constantsService.recursoCuponsAvancados$.subscribe(data => this.possuiRecursoCuponsAvancados = data && !this.ehGarcom);
    this.constantsService.recursoTemasPersonalizados$.subscribe(data => this.possuiRecursoTemasPersonalizados = data && !this.ehGarcom);
    this.constantsService.recursoLinkNaBio$.subscribe(data => this.possuiRecursoLinkNaBio = data && !this.ehGarcom);
    this.constantsService.recursoInteligenciaNegocio$.subscribe(data => this.possuiRecursoInteligenciaNegocio = data && !this.ehGarcom);
    this.constantsService.recursoCampanhasWhatsapp$.subscribe(data => this.possuiRecursoCampanhasWhatsapp = data && !this.ehGarcom);
    this.constantsService.recursoNotificacoesAppProprio$.subscribe(data => this.possuiRecursoNotificacoesAppProprio = data && !this.ehGarcom);
    this.constantsService.recursoFerramentasMarketing$.subscribe(data => this.possuiRecursoFerramentasMarketing = data && !this.ehGarcom);
    this.constantsService.moduloEstoque$.subscribe(data =>
      this.exibirEstoque = data && !this.ehGarcom && !this.empresa.estoqueVinculadoProduto);

    this.constantsService.moduloFidelidade$.subscribe(data => this.exibirFuncoesFidelidade = data && !this.ehGarcom);
    this.constantsService.moduloChatbot$.subscribe( data => this.exibirFuncoesChatbot = data && !this.ehGarcom);
    this.constantsService.moduloMiaV3$.subscribe( data => this.possuiModuloMiaV3 = data && !this.ehGarcom);
    this.constantsService.moduloGarcom$.subscribe( data => this.possuiModuloGarcom = data && !this.ehGarcom);

    this.constantsService.moduloApp$.subscribe( data => this.possuiModuloApp = data && !this.ehGarcom);
    this.constantsService.moduloChatbotInstagram$.subscribe( (data) => {
      this.possuiModuloInstagramBot = data && !this.ehGarcom
    });
    this.constantsService.somenteCardapio$.subscribe(data => {
      this.somenteCardapio = data;
    });
    this.monitoradorPedidos.resumoMesas$.subscribe( resumo =>  {
       this.resumoMesas = resumo || {}
    })
    this.monitoradorPedidos.resumoPedidos$.subscribe( resumo =>  {
       if(resumo)  this.resumoPedidos = resumo ;
    })

    this.monitoradorPedidos.mesasComErros$.subscribe( resumo =>  {
       if(resumo && resumo.totalErroParceiroMesa)
         this.resumoPedidos.totalErroParceiroMesa = resumo.totalErroParceiroMesa ;
    })

    this.monitoradorPedidos.resumoEstoque$.subscribe( resumo =>  {
      if(resumo && resumo.totalAlertas)
        this.resumoEstoque.totalAlertas = resumo.totalAlertas ;
    })

  }

  naveguePara( url: string ) {
    this.router.navigateByUrl( '/admin/' + url).then( (resposta: boolean) => {
      if( !resposta ) {
        return;
      }

      if(document.body.classList.contains('sidebar-enable'))
        this.renderer.removeClass(document.body, 'sidebar-enable')
      else
        this.renderer.addClass(document.body, 'sidebar-enable')

      this.url = url;
    });
  }

  visualizarLoja() {
     return RotaGuardClient.gerenciaLoja(this.usuario)
  }

  visualizarMenuLoja() {
    return this.visualizarLoja() || this.visualizarUsuariosLoja()
  }

  visualizarUsuariosLoja() {
    return RotaGuardClient.gerenciarUsuariosLoja(this.usuario)
  }

  urlInicialLoja() {
    return this.visualizarLoja() ? 'loja' : 'loja/tab/usuarios'
  }

  lojaEstaAtiva() {
    return this.url === 'qrcodes'
      || this.url === 'taxas'
      || this.url === 'areas-entrega'
      || this.url === 'temas'
      || this.url === 'loja'
      || this.url === 'loja/numeros-whatsapp'
      || this.url === 'loja/dispositivos-whatsapp'
      || this.url.indexOf('loja/tab/') === 0
      || this.url === 'loja/tab/:nometab';
  }

  abaUsuariosEstaAtiva() {
    return this.visualizarUsuariosLoja()
      && (this.url === 'loja/tab/usuarios'
        || (this.url === 'loja/tab/:nometab' && this.location.path().indexOf('/admin/loja/tab/usuarios') >= 0));
  }

  visualizarCaixa() {
    return RotaGuardClient.operarCaixa(this.usuario)
  }

  visualizarNotificacoes(){
    return RotaGuardClient.cadastrarNotificacoes(this.usuario)
  }

  visualizarContatos(){
    return RotaGuardClient.cadastrarContatos(this.usuario)
  }

  visualizaRelatorios(){
    return RotaGuardClient.visualizaRelatorios(this.usuario)
  }

  urlInicialFinanceiro() {
    if(this.exibirFuncoesPedidos) return 'financeiro-delivery';
    if(this.exibirFuncoesMesas) return 'financeiro-mesas';
    return 'financeiro-balcao';
  }

  visualizarAnalyticsCardapio(): boolean {
    const possuiPermissao = !!this.usuario?.superadmin || RotaGuardClient.gerenciaLoja(this.usuario);
    return possuiPermissao && this.constantsService.possuiRecurso(this.empresa, RecursosEnum.ANALYTICS_CARDAPIO);
  }

  temIntegracaoParceiro() {
    return this.possuiRecursoIntegracaoPdvParceiros && this.empresa.integracaoDelivery != null;
  }

  vendeOnline(){
    if(!this.possuiRecursoIntegracaoGatewayPagamento) return false;

    let formaPagametento = this.empresa.formasDePagamento.find((item: any) => item.online);

    return formaPagametento != null;

  }

  integracaoIfood(){
    return this.possuiRecursoIntegracaoMarketplacesDelivery && this.empresa && this.empresa.integracoesIfood.length
  }

  toggleSubmenu(event: any, targetId: string) {


  }

  abraModalFecharLoja(){
     this.onFecharLoja.emit({});
  }

  abraModalGerenciarJobs(){
    this.onGerenciarJobs.emit({})
  }

  abraModalReabrirLoja(){
    this.onAbrirLoja.emit({})
  }

  /** QA da Mia: só admin do MeuCardápio (mesma regra do backend), o dono da loja não vê. */
  get ehAdminMeuCardapio(): boolean {
    return !!(this.usuario && (this.usuario.admin || this.usuario.superadmin));
  }

  identificarNumeroWhatsappPrincipal() {
    if (this.empresa && this.empresa.numeroWhatsapp) {
      this.numeroWhatsappPrincipal = this.empresa.numeroWhatsapp.whatsapp;
    } else if (this.empresa && this.empresa.whatsapp) {
      this.numeroWhatsappPrincipal = this.empresa.whatsapp;
    } else {
      this.numeroWhatsappPrincipal = '';
    }
  }

  protected readonly serialization = serialization;
}
